module.exports = __webpack_public_path__ + "static/img/layer6.9bc0629e.png";